import * as Types from './PageComponents';

export const AllowedComponent = Object.values(Types).map(comp => comp.displayName || comp.name);
